export default {
  title: 'Charge Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Charge code, charge name, external relation',
    currency: 'Currency',
    currencyPlaceholder: 'Select currency',
    status: 'Status',
    statusPlaceholder: 'Select status',
    basicFee: 'Basic Fee',
    basicFeePlaceholder: 'Select type',
    transportMode: 'Transport Business Type',
    transportModePlaceholder: 'Select transport business type',
    all: 'All',
    enabled: 'Enabled',
    disabled: 'Disabled',
    yes: 'Yes',
    no: 'No',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addFee: 'Add Charge',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    feeCode: 'Charge Code',
    feeNameCn: 'Charge Name',
    feeNameEn: 'Charge Name (English)',
    currency: 'Currency',
    transportMode: 'Transport Business Type',
    basicFee: 'Basic Fee',
    billingUnit: 'Billing Unit',
    externalRelatedItem: 'External Related Item',
    externalRelationName: 'External Relation Name',
    feeCategory: 'Fee Category',
    externalId: 'External System ID',
    externalSource: 'External System',
    createdBy: 'Created By',
    modifiedBy: 'Modified By',
    dateCreated: 'Created Time',
    dateModified: 'Modified Time',
    taxRate: 'Tax Rate',
    status: 'Status',
    operation: 'Operation',
    dataFormatError: 'Data format error',
    noData: '-'
  },

  // Form modal
  form: {
    addTitle: 'Add Charge',
    editTitle: 'Edit Charge',
    feeCode: 'Charge Code',
    feeCodePlaceholder: 'Enter charge code, e.g.: DGSBF',
    currency: 'Currency',
    currencyPlaceholder: 'Select currency',
    transportMode: 'Transport Business Type',
    transportModePlaceholder: 'Select transport business type',
    feeCategory: 'Fee Category',
    feeCategoryPlaceholder: 'Select fee category (logistics stage)',
    feeNameCn: 'Charge Name (Chinese)',
    feeNameCnPlaceholder: 'Enter Chinese charge name',
    feeNameEn: 'Charge Name (English)',
    feeNameEnPlaceholder: 'Enter English charge name',
    isBasicFee: 'Is Basic Fee',
    isBasicFeePlaceholder: 'Please select',
    billingUnit: 'Associated Billing Units',
    externalRelatedItem:'External Related Item',
    externalRelatedItemPlaceholder: 'Enter external related item',
    externalRelationName: 'External Relation Name',
    externalRelationNamePlaceholder: 'Enter external relation name',
    billingUnitPlaceholder: 'Select billing units',
    defaultPayable: 'Default payable',
    externalVisible: 'Externally visible',
    defaultUnit: 'Default units',
    defaultUnits: {
      fcl: 'Ocean FCL',
      lcl: 'Ocean LCL',
      air: 'Air',
      preport: 'Pre-port',
      lastmile: 'Last mile',
      rail: 'Rail'
    },
    taxRate: 'Tax Rate',
    taxRatePlaceholder: 'Enter tax rate (0-100)',
    yes: 'Yes',
    no: 'No'
  },

  // Currency options
  currency: {
    CNY: 'CNY - Chinese Yuan',
    USD: 'USD - US Dollar',
    EUR: 'EUR - Euro',
    JPY: 'JPY - Japanese Yen',
    GBP: 'GBP - British Pound',
    HKD: 'HKD - Hong Kong Dollar'
  },

  // Fee category (stored as Chinese per backend API)
  feeCategory: {
    prePort: 'Pre-port',
    mainline: 'Mainline',
    lastMile: 'Last Mile',
    fullJourney: 'End-to-end'
  },

  // Confirmation dialogs
  confirm: {
    enableTitle: 'Confirm Enable',
    disableTitle: 'Confirm Disable',
    enableContent: 'Are you sure to set this charge status to enabled?',
    disableContent: 'Are you sure to set this charge status to disabled?',
    batchEnableTitle: 'Confirm Batch Enable',
    batchDisableTitle: 'Confirm Batch Disable',
    batchEnableContent: 'Are you sure to set the selected {count} charges to enabled status?',
    batchDisableContent: 'Are you sure to set the selected {count} charges to disabled status?'
  },

  // Form validation
  validation: {
    feeCodeRequired: 'Please enter charge code',
    feeNameCnRequired: 'Please enter charge name (Chinese)',
    feeNameEnRequired: 'Please enter charge name (English)',
    currencyRequired: 'Please select currency',
    isBasicFeeRequired: 'Please select if it is a basic fee',
    billingUnitRequired: 'Please select billing units',
    feeCategoryRequired: 'Please select fee category',
    transportModeRequired: 'Please select a transport business type for an enabled mainline basic fee',
    externalRelatedItemRequired: 'Please enter external related item',
    externalRelatedItemTooLong: 'External related item cannot exceed 255 characters',
    externalRelationNameTooLong: 'External relation name cannot exceed 255 characters'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select charges to enable',
    selectToDisable: 'Please select charges to disable',
    loadError: 'Failed to load data',
    currencyLoadError: 'Failed to load currency options',
    billingUnitLoadError: 'Failed to load billing units',
    statusUpdateSuccess: 'Charge status updated to {status}',
    batchEnableSuccess: 'Charges have been batch updated to enabled',
    batchDisableSuccess: 'Charges have been batch updated to disabled',
    saveSuccess: 'Charge information added successfully',
    updateSuccess: 'Charge information updated successfully',
    relationUpdateError: 'Charge information saved successfully, but failed to update relations',
    relationAddError: 'Charge information saved successfully, but failed to add relations'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled',
    yes: 'Yes',
    no: 'No'
  }
}
